import styled from "styled-components";

const Switch = ({ isOn, handleToggle, id }) => {
  return (
    <SwitchWrap>
      <input
        checked={isOn}
        onChange={handleToggle}
        className="switch-checkbox"
        id={id}
        type="checkbox"
      />
      <label
        className={isOn ? "switch-label isOn" : "switch-label"}
        htmlFor={id}
      >
        <span className={`switch-button`} />
      </label>
    </SwitchWrap>
  );
};
export default Switch;
const SwitchWrap = styled.div`
  .switch-checkbox {
    height: 0;
    width: 0;
    visibility: hidden;
    display: none;
  }

  .switch-label {
    display: block;
    cursor: pointer;
    width: 52px;
    height: 28px;
    background-color: ${({ theme }) => theme.color.toggle_disabled};
    border-radius: 26px;
    position: relative;
    transition: background-color 0.2s;
  }

  .switch-label .switch-button {
    /* content: ""; */
    position: absolute;
    top: 2px;
    left: 2px;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    transition: 0.2s;
    background-color: ${({ theme }) => theme.color.white};
  }
  .isOn {
    background-color: ${({ theme }) => theme.color.purple_secondary};
  }

  .switch-checkbox:checked + .switch-label .switch-button {
    right: calc(100% - 2px);
    transform: translateX(100%);
  }

  .switch-label:active .switch-button {
    width: 24px;
  }
`;
